import {Component, EventEmitter, Input, OnInit} from "@angular/core";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {Subscription} from "rxjs";
import {Organization} from "../../models/organization";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private organizationLoadedSubscription: Subscription;
  reloadHistorical: EventEmitter<any> = new EventEmitter<any>();
  organization: Organization;
  @Input() data;

  constructor(private organizationTreeSelect: OrganizationTreeSelect) {
  }

  ngOnInit() {
    this.organization = this.organizationTreeSelect.distributor || this.organizationTreeSelect.site || this.organizationTreeSelect.company;
    this.organizationLoadedSubscription = this.organizationTreeSelect.organizationLoadedEvent$.subscribe(() => {
      this.organization = this.organizationTreeSelect.distributor || this.organizationTreeSelect.site || this.organizationTreeSelect.company;
    })
  }

  ngOnDestroy() {
    this.organizationLoadedSubscription.unsubscribe();
  }
}
